// AGC: FarmProHub main entry point
// AGC: Uses shared providers from @farmprohub/shared

import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit'
import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { baseSepolia, base } from 'wagmi/chains'
import { http } from 'wagmi'
import App from './App'
import './index.css'

import '@rainbow-me/rainbowkit/styles.css'

// AGC: Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 3,
    },
  },
})

// AGC: Create wagmi config for FarmProHub
const config = getDefaultConfig({
  appName: 'FarmProHub',
  projectId: '9ca2e6ed298a79b2ebdcdc8fcef3ddfe', // AGC: FarmProHub WalletConnect Project ID
  chains: [baseSepolia, base],
  transports: {
    [baseSepolia.id]: http('https://sepolia.base.org'),
    [base.id]: http('https://mainnet.base.org'),
  },
  ssr: false,
})

// AGC: RainbowKit theme
const theme = darkTheme({
  accentColor: '#22c55e',
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={config}>
        <RainbowKitProvider theme={theme} modalSize="compact">
          <App />
        </RainbowKitProvider>
      </WagmiProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
